import { ComponentProps } from 'react';
import { FieldWrapper } from '../FieldWrapper';
import { DatePicker } from '../FormItems/DatePicker';

type FieldWrapperProps = ComponentProps<typeof FieldWrapper>;

type Props = {
  datePicker?: ComponentProps<typeof DatePicker>;
  fieldWrapperProps: Omit<FieldWrapperProps, 'children'>;
};

/**
 * DatePicker を FieldWrapper でラップした dumb コンポーネント。
 * RHF に依存しない。フォーム統合には DatePickerFieldController を使用すること。
 *
 * @param datePicker - DatePicker に渡す props
 * @param fieldWrapperProps - FieldWrapper に渡す props（children を除く）
 */
export const DatePickerField: React.FC<Props> = ({
  datePicker,
  fieldWrapperProps: { htmlFor, labelType, labelText, beforeMessage, errorMessages, disabled },
}) => (
  <FieldWrapper
    htmlFor={htmlFor}
    labelType={labelType}
    labelText={labelText}
    beforeMessage={beforeMessage}
    errorMessages={errorMessages}
    disabled={disabled}
  >
    <DatePicker {...datePicker} />
  </FieldWrapper>
);
